import React from 'react';

import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';

import SingleColumnTemplate from '@/components/layouts/SingleColumnTemplate';
import { pageTitles } from '@/constants/pageTitles';

import InvitationRegisterCompleteForm from './InvitationRegisterCompleteForm';

const InvitationRegisterCompletePage: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigateToLogin = () => {
    navigate('/login');
  };

  return (
    <SingleColumnTemplate>
      <Helmet>
        <title>{pageTitles.invitationRegisterComplete}</title>
      </Helmet>
      <InvitationRegisterCompleteForm
        onNavigateToLogin={handleNavigateToLogin}
      />
    </SingleColumnTemplate>
  );
};

export default InvitationRegisterCompletePage;
